/*
FHT currently uses - Prettier formatting followed by Airbnb coding style guidelines.

This file displays the front landing page (which is currently the login dialog) and the navigation bar. 
This file contains the navigation bar.
The login dialog is located under: ./FhtMainComponents/LoginDialog.jsx
The Guideline dialog is located under: ./FhtMainComponents/Guideline.jsx
The Contact dialog is located under: ./FhtMainComponents/ContactDialog.jsx
Try to keep each file under 1-2 thousand lines long. Definitely break the components up if they ARE reused or long/isolated/complex enough to warrant their own files.

Todo:
A global FHT makestyle MUI for all components

Light reading - things to avoid:
https://www.doc.ic.ac.uk/~susan/475/unmain.html
*/

import React, { Component } from 'react';

import 'App.css';
import Configs from 'Configuration';
import SiteConfigurationContext from '../Utils/SiteConfigurationContext.jsx';
import BatchSiteConfigurationContext from '../Utils/BatchSiteConfigurationContext.jsx';

import FhtMain from "../FhtMain";

import {
  BrowserRouter as Router,
  Route,
  Switch,
  Redirect,
} from 'react-router-dom';

import LoginDialog from 'FhtMainComponents/LoginDialog.jsx';
import LoadingScreen from 'components/LoadingScreen';
import SnackbarContentWrapper from 'components/SnackbarContentWrapper';

import { createTheme } from '@material-ui/core/styles';
import { ThemeProvider, withTheme } from '@material-ui/styles';
import styled from '@emotion/styled';

import {
  AppBar,
  Box,
  CssBaseline,
  Divider,
  Drawer,
  List,
  ListItem,
  ListItemIcon,
  ListItemText,
  Snackbar,
  Toolbar,
  Typography,
} from '@material-ui/core';

import {
  AccountBox,
  Event,
  Home,
  People,
  Sms,
  Timer
} from '@material-ui/icons';

import './linkme.css';

import LinkmeAppointmentEligibility from './SmsManagement/LinkmeAppointmentEligibility.jsx';
import LinkmeDoctorEligibility from './SmsManagement/LinkmeDoctorEligibility.jsx';
import LinkmeHome from './SmsManagement/LinkmeHome.jsx';
import LinkmeSmsContent from './SmsManagement/LinkmeSmsContent.jsx';
import LinkmeSmsTiming from './SmsManagement/LinkmeSmsTiming.jsx';
import LinkmeUserProfile from './LinkmeUserProfile.jsx';

const theme = createTheme({
  overrides: {
    MuiCssBaseline: {
      '@global': {
        body: {
          backgroundColor: "#fafafa"
        },
      },
    }
  },
  typography: {
    h1: {
      fontFamily: ["Montserrat", "sans-serif"].join(","),
      fontWeight: 500
    },
    h2: {
      fontFamily: ["Montserrat", "sans-serif"].join(","),
      fontWeight: 500
    },
    h3: {
      fontFamily: ["Montserrat", "sans-serif"].join(","),
      fontWeight: 600
    },
  },
  palette: {
    primary: {
      main: "#0196cc",
      light: "#31b1de",
      dark: "#0073a6",
    },
    secondary: {
      main: "#48AF68",
      light: "#6cbf86",
      dark: "#327a48"
    },
  },
  shape: {
    borderRadius: 16
  }
});

const DrawerList = styled(List)(() => {
  return {
    '&': {
      marginLeft: 12,
      marginRight: 12,
    },
    '& .MuiListItem-root': {
      color: theme.palette.text.primary,
      borderRadius: theme.shape.borderRadius,
      marginTop: 12,
      marginBottom: 12,
      paddingLeft: 16,
      paddingRight: 16,
      paddingTop: 6,
      paddingBottom: 6,
    },
    '& .MuiListItem-root.Mui-selected': {
      color: theme.palette.primary.main,
      backgroundColor: "rgba(0, 0, 0, 0.04)"
    },
    '& .MuiListItem-root.Mui-selected .MuiListItemIcon-root': {
      color: theme.palette.primary.main,
    },
    '& .MuiListItemIcon-root': {
      minWidth: 0,
      marginRight: 16,
    },
    '& .MuiSvgIcon-root': {
      fontSize: 20,
    },
  };
});

class FhtLinkmeDashboard extends Component {
  constructor(props) {
    super(props);
    this.state = {
      // Snackbar related states
      openSnackbar: false,
      snackbarMessage: 'No message',
      snackbarVariant: Configs.snackbarVariants.info,
      userIsLoggedIn: false,
      checkLogin: true,
      loadingScreen: true, // The App uses this to determine when to display a loading screen or if a user is logged in.

      // Used to open the profile context menu
      OpenProfileContextMenuAnchor: null,

      // Change password screen variables
      showChangePasswordDialog: false,
      password: null,
      newPassword: null,
      retypePassword: null,
      showNewPassword: false,
      showRetypePassword: false,

      siteConfigurationContext: SiteConfigurationContext(),
      batchSiteConfigurationContext: BatchSiteConfigurationContext(),
      //////////////////////
      // TAG: MEGA MENU CODE
      //////////////////////
      showScreenMenu: false,
      showCohortDropDownMenu: true,
      showQIDropDownMenu: true,
      hover: false
    };

    // This async callback passed down to the other forms to display a snackbarmessage.
    this.GlobalFunctionDisplaySnackbarMessage = this.GlobalFunctionDisplaySnackbarMessage.bind(this);

    // Async callback when login dialog is successful. The login dialog is close to 500 lines long so it is worth partitioning into a different file, requiring a callback.
    this.CallbackLoginDialogSuccess = this.CallbackLoginDialogSuccess.bind(this);

    // The profile, change passwords, and other dialog boxes can call this to update their display state.
    this.CallbackForAllDialogsClose = this.CallbackForAllDialogsClose.bind(this);
    // As FHT starts up, we start by checking if a login token exists in the localstorage
    this.existingToken = localStorage.getItem(Configs.userTokenInformation.userToken);
    // eslint-disable-next-line
    if (this.existingToken != null && this.existingToken != undefined) {
      // Validate the user token. If it fails, display the login screen.
      if (window.location.pathname === '/POCAutoLogin/') {
        console.log('Incoming from POC - use special route');
      } else {
        console.log('Token found, attempting to validate user');
        this.authenticateExistingToken(this.existingToken);
      }
    } else {
      this.state.loadingScreen = false;
    }

    //////////////////////
    // TAG: MEGA MENU CODE
    //////////////////////
    this.showScreenMenu = this.showScreenMenu.bind(this);
    this.closeScreenMenu = this.closeScreenMenu.bind(this);
    const style = document.getElementById('style-direction');
    if (this.state.batchSiteConfigurationContext['IsTorch'] == 'true') {
      console.log('IsTorch is true. Starting up torch.');
      document.title = 'TorchRecruit';
    } else {
      console.log('IsTorch is false. Starting up fht.');
      document.title = 'Future Health Today';
    }
  }

  showScreenMenu(event) {
    event.preventDefault();

    this.setState({ showScreenMenu: true }, () => {
      document.addEventListener('click', this.closeScreenMenu);
    });
  }

  closeScreenMenu(event) {
    if (!this.dropdownMenu.contains(event.target)) {
      this.setState({ showScreenMenu: false }, () => {
        document.removeEventListener('click', this.closeScreenMenu);
      });
    }
  }

  closeScreenMenuTwo(event) {
    this.setState({ showScreenMenu: false });
  }

  GlobalFunctionDisplaySnackbarMessage = (msg, variant) => {
    this.setState({ snackbarMessage: msg, snackbarVariant: variant, openSnackbar: true });
  };

  //LoginDialog is in a different file, so it will require a callback mechanism as a successful login needs to be returned to FhtLinkmeDashboard
  CallbackLoginDialogSuccess = e => {
    this.handleClaimsToMainScreenMapping(e);
    this.setState({ userIsLoggedIn: true, loadingScreen: false });
  };

  // If there's multiple types of dialog boxes being opened in the app, this should close all of them.
  // Not as efficient as setting one variable of course, but this is much clearer in the code.
  CallbackForAllDialogsClose() {
    this.setState({

    });
  }

  handleSetLogin = visible => {
    console.log(visible);
    this.setState({ checkLogin: visible });
  };

  handleClaimsToMainScreenMapping(claims) {
    let menuOptions = [];
    this.setState({ navbarMenu: menuOptions, currentScreen: Configs.userClaims.TriageScreen });
  }

  render() {
    console.log('Linkme dashboard render');

    return (
      <ThemeProvider theme={theme}>
        <CssBaseline />
        <Box sx={{ display: "flex" }}>
          <Drawer variant="permanent" style={{ flexShrink: 0, width: 320 }}>
            <Box paddingLeft="28px" paddingTop="16px" marginBottom="-8px">
              <img src="https://fhtwebpublicaccess.s3.ap-southeast-2.amazonaws.com/linkme-logo-dark.png" height={60} />
            </Box>

            <Box sx={{ overflow: "auto", boxSizing: "border-box", width: 320 }}>
              <DrawerList component="nav">
                <ListItem
                  button
                  key="linkme-navigation-home"
                  component="a"
                  href="/linkme/"
                  selected={window.location.pathname === "/linkme/"}
                >
                  <ListItemIcon><Home /></ListItemIcon>
                  <ListItemText primary="Home" />
                </ListItem>
                <Divider />
                <ListItem
                  button
                  key="linkme-navigation-sms-content"
                  component="a"
                  href="/linkme/sms-content"
                  selected={window.location.pathname === "/linkme/sms-content"}
                >
                  <ListItemIcon><Sms /></ListItemIcon>
                  <ListItemText primary="SMS content" />
                </ListItem>
                <ListItem
                  button
                  key="linkme-navigation-sms-timing"
                  component="a"
                  href="/linkme/sms-timing"
                  selected={window.location.pathname === "/linkme/sms-timing"}
                >
                  <ListItemIcon><Timer /></ListItemIcon>
                  <ListItemText primary="SMS timing" />
                </ListItem>
                <ListItem
                  button
                  key="linkme-navigation-appointment-eligibility"
                  component="a"
                  href="/linkme/appointment-eligibility"
                  selected={window.location.pathname === "/linkme/appointment-eligibility"}
                >
                  <ListItemIcon><Event /></ListItemIcon>
                  <ListItemText primary="Appointment eligibility & intervals" />
                </ListItem>
                <ListItem
                  button
                  key="linkme-navigation-doctor-eligibility"
                  component="a"
                  href="/linkme/doctor-eligibility"
                  selected={window.location.pathname === "/linkme/doctor-eligibility"}
                >
                  <ListItemIcon><People /></ListItemIcon>
                  <ListItemText primary="Doctors eligible for Linkme+" />
                </ListItem>
                <Divider />
                <ListItem
                  button
                  key="linkme-navigation-my-account"
                  component="a"
                  href="/linkme/my-account"
                  selected={window.location.pathname === "/linkme/my-account"}
                >
                  <ListItemIcon><AccountBox /></ListItemIcon>
                  <ListItemText primary="My Account" />
                </ListItem>
              </DrawerList>
            </Box>
          </Drawer>

          <Box flexGrow={1} padding={5} overflow="auto">
            {this.state.loadingScreen ?
              <LoadingScreen /> :
              this.state.userIsLoggedIn &&
              <Router>
                <Switch>
                  <Route exact path="/" render={() => <Redirect to='/linkme/' />} />
                  <Route exact path="/linkme/" component={LinkmeHome} />
                  <Route exact path="/linkme/sms-content" component={LinkmeSmsContent} />
                  <Route exact path="/linkme/sms-timing" component={LinkmeSmsTiming} />
                  <Route exact path="/linkme/appointment-eligibility" component={LinkmeAppointmentEligibility} />
                  <Route exact path="/linkme/doctor-eligibility" render={props => <LinkmeDoctorEligibility {...props} GlobalFunctionDisplaySnackbarMessage={this.GlobalFunctionDisplaySnackbarMessage} />} />
                  <Route exact path="/linkme/my-account" component={LinkmeUserProfile} />
                </Switch>
              </Router>
            }
          </Box>

          {/* Display loading screens & login dialogs if the user is not logged in. Loading is displayed while attempting a connection to login */}
          {this.state.userIsLoggedIn === false && this.state.checkLogin && (
            <div>
              {this.state.loadingScreen === false && (
                <LoginDialog
                  CallbackLoginDialogSuccess={this.CallbackLoginDialogSuccess}
                  GlobalFunctionDisplaySnackbarMessage={this.GlobalFunctionDisplaySnackbarMessage}
                />
              )}
            </div>
          )}

          {/* Snackbar (message popup on corner bottom right of screen) to inform user of a success/failure/info operation from any form */}
          {this.state.openSnackbar && (
            <Snackbar
              anchorOrigin={{ vertical: 'bottom', horizontal: 'right' }}
              open={this.state.openSnackbar}
              autoHideDuration={4000}
              onClose={() => this.setState({ openSnackbar: false })}
            >
              <SnackbarContentWrapper
                onClose={() => this.setState({ openSnackbar: false })}
                variant={this.state.snackbarVariant}
                message={this.state.snackbarMessage}
              />
            </Snackbar>
          )}
        </Box>
      </ThemeProvider>
    );
  }

  onMenuBtnSignout = () => {
    console.log('Signing out');
    localStorage.removeItem(Configs.userTokenInformation.userToken);
    FhtMain.GlobalContext = {
      userClaims: null,
      userRole: null,
      userName: null,
      userToken: null,
      viewableCohortIds: null,
      cohortDiseaseId: null
    };
    let menuOptions = [];
    this.setState({
      OpenProfileContextMenuAnchor: null,
      userIsLoggedIn: false,
      navbarMenu: menuOptions
    });
    window.history.pushState("", "", "/");
    window.history.go();
  };

  //The dialog box has logged in successfully. We need to trigger a re-render.
  ChildLoginSuccess() {
    console.log('ChildLoginSuccess fired');
    this.setState({ userIsLoggedIn: true });
  }

  onMenuBtnProfileMenu = event => {
    console.log('Open user profile');
    this.setState({ OpenProfileContextMenuAnchor: event.currentTarget });
  };
  onMenuBtnProfileMenuClose = () => {
    this.setState({ OpenProfileContextMenuAnchor: null });
  };

  onHandleClick(e) {
    console.log(e);
    this.setState({ openSnackbar: true });
    FhtMain.GlobalContext.userClaims = '[2]';
    console.log(`In LinkmeDashboard: FhtLinkmeDashboard.GlobalContext.userClaims value is: ${FhtMain.GlobalContext.userClaims}`);
    this.setState({ userIsLoggedIn: true });
  }

  //The point of care should not attempt to save a token - this locks the user into a screen without a navigation bar when they visit futurehealthtoday
  authenticateExistingToken(tokenString) {
    let siteConfiguration = SiteConfigurationContext();
    //Special fetch-> Not using the library fetch because we need to retrieve the token from localstorage.
    console.log('Fetching ' + tokenString);
    console.log(
      'Token validation url:',
      siteConfiguration[Configs.SiteConfigurationMappingKeys.serverapi] +
      Configs.checkValidTokenLink
    );
    fetch(
      siteConfiguration[Configs.SiteConfigurationMappingKeys.serverapi] +
      Configs.checkValidTokenLink,
      {
        method: 'GET',
        headers: {
          'Content-Type': 'application/json',
          'cache-control': 'no-cache',
          Authorization: 'Bearer ' + tokenString
        }
      }
    )
      .then(parseJSON)
      .then(response => {
        if (response.ok) {
          console.log('Authenticate token response:', response.json);
          console.log('GlobalContext value:', FhtMain.GlobalContext);
          FhtMain.GlobalContext.userToken = tokenString;
          FhtMain.GlobalContext.userClaims = response.json.claims;
          FhtMain.GlobalContext.userName = response.json.userName;
          FhtMain.GlobalContext.fullName = response.json.fullName;
          FhtMain.GlobalContext.userRole = response.json.userRole;
          console.log('GlobalContext value:', FhtMain.GlobalContext);
          console.log('response claims from token validation:', response.json.claims);
          console.log('Setting userIsLoggedIn state to true');
          this.setState({ loadingScreen: false, userIsLoggedIn: true });
          console.log('Setting userIsLoggedIn state is set');
        } else {
          console.log('Log in is unsuccessful.');
          throw response.json.message;
        }
      })
      .catch(error => {
        console.log('ERROR:' + error);
        this.setState({ loadingScreen: false });
      });
  }
}

function parseJSON(response) {
  if (response.ok) {
    return new Promise(resolve =>
      response.json().then(json =>
        resolve({
          status: response.status,
          ok: response.ok,
          json
        })
      )
    );
  }
  throw response.statusText;
}

export default FhtLinkmeDashboard;
